import { motion } from "framer-motion";
import { Instagram, MessageCircle, Mail } from "lucide-react";
import HexLogo from "../HexLogo";
import Reveal from "../Reveal";
import { CONTACT } from "../../lib/brand";

export const SiteFooter = () => (
  <footer
    id="contact"
    data-testid="footer-section"
    className="relative overflow-hidden bg-[#030303] border-t border-white/5 pt-28 pb-12"
  >
    <div className="pointer-events-none absolute -bottom-40 left-1/2 -translate-x-1/2 w-[700px] h-[700px] teal-radial" />

    <div className="relative z-10 mx-auto max-w-[1400px] px-6 lg:px-12">
      <Reveal>
        <p className="font-mono text-[11px] tracking-[0.4em] text-teal-300 text-center">
          BEGIN THE RITUAL
        </p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-6 text-center font-serif font-light tracking-tighter text-6xl md:text-9xl text-zinc-50 leading-[0.9]">
          Let&apos;s <span className="italic text-teal-300">Manifest.</span>
        </h2>
      </Reveal>

      <div className="mt-16 flex flex-col sm:flex-row items-center justify-center gap-5">
        <motion.a
          href={CONTACT.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-whatsapp"
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.98 }}
          className="inline-flex items-center gap-3 rounded-full bg-teal-400 px-8 py-4 text-black font-medium hover:bg-teal-300 transition-colors"
        >
          <MessageCircle size={18} /> WhatsApp Us
        </motion.a>
        <motion.a
          href={CONTACT.instagram}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-instagram"
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.98 }}
          className="inline-flex items-center gap-3 rounded-full border border-white/20 px-8 py-4 text-zinc-100 hover:border-teal-300 hover:text-teal-200 transition-colors"
        >
          <Instagram size={18} /> {CONTACT.instagramHandle}
        </motion.a>
      </div>

      <div className="mt-24 grid grid-cols-1 md:grid-cols-3 gap-10 border-t border-white/5 pt-12">
        <div className="flex items-center gap-3">
          <HexLogo className="w-14 h-14" />
        </div>

        <div className="space-y-3">
          <a
            href={`mailto:${CONTACT.email}`}
            data-testid="footer-email"
            className="flex items-center gap-2 font-glacial text-lg md:text-xl text-zinc-300 hover:text-teal-300 transition-colors"
          >
            <Mail size={18} /> {CONTACT.email}
          </a>
          <a
            href={CONTACT.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 font-glacial text-lg md:text-xl text-zinc-300 hover:text-teal-300 transition-colors"
          >
            <MessageCircle size={18} /> {CONTACT.whatsappLabel}
          </a>
        </div>

        <p className="font-light text-sm text-zinc-500 md:text-right">
          Extracted and bottled near the Gangapur Dam, from the sacred aquifers
          of Nashiik.
        </p>
      </div>

      <p className="mt-12 text-center font-mono text-[10px] tracking-[0.3em] text-zinc-600">
        © {new Date().getFullYear()} MANIFEST WITH WATERBOAT · #NASHIKCHAPANI
      </p>
    </div>
  </footer>
);

export default SiteFooter;
